import { FC, memo } from 'react'

import { Form } from 'brief-form'
import { BankAccountSelect, ContactSelect, LicenseSelect, Select } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'

import { FilterProps } from './FilterProps'

import { FormBox, SelectWrapper } from './styles'

export const Filter: FC<FilterProps> = memo((props) => {
  const {
    form: { config, isDirty, Field },
    expanded,
    onToggle,
    isSubjectHidden,
    data,
    onClear
  } = props
  const subjectType = config?.value?.subjectType

  const showLicenseFilter = subjectType === 'license'
  const showContactFilter = subjectType === 'contact'
  const showBankAccountFilter = subjectType === 'bank-account'

  return (
    <FilterPanel isDirty={isDirty} onReset={onClear} expanded={expanded} onToggle={onToggle}>
      <Form config={config}>
        <FormBox>
          <SelectWrapper>
            <Field
              name="isInternal"
              label="Internal"
              input={Select}
              inputProps={{
                data: data.documentsInternalOptions
              }}
            />
          </SelectWrapper>
          {!isSubjectHidden && (
            <SelectWrapper>
              <Field
                name="subjectType"
                label="Subject Type"
                input={Select}
                inputProps={{
                  data: data.documentsSubjectTypeOptions
                }}
              />
            </SelectWrapper>
          )}
          {showLicenseFilter && (
            <SelectWrapper>
              <Field name="licenseId" label="License" input={LicenseSelect} inputProps={{}} />
            </SelectWrapper>
          )}
          {showContactFilter && (
            <SelectWrapper>
              <Field name="contactId" label="Contact" input={ContactSelect} inputProps={{}} />
            </SelectWrapper>
          )}
          {showBankAccountFilter && (
            <SelectWrapper>
              <Field
                name="bankAccountId"
                label="Bank Account"
                input={BankAccountSelect}
                inputProps={{
                  defaultOption: { label: 'All', value: 0 }
                }}
              />
            </SelectWrapper>
          )}
          <SelectWrapper>
            <Field
              name="frequency"
              label="Frequency"
              input={Select}
              inputProps={{
                data: data.documentsFrequencyOptions
              }}
            />
          </SelectWrapper>
          <SelectWrapper>
            <Field
              name="alerts"
              label="Alerts"
              input={Select}
              inputProps={{
                data: data.documentsAlertsOptions
              }}
            />
          </SelectWrapper>
        </FormBox>
      </Form>
    </FilterPanel>
  )
})
